<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card style="border-radius: 1.5em;">
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha inicial</label>
                <vs-input type="date"
                          v-model="initialDate"
                          class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha final</label>
                <vs-input type="date"
                          v-model="finalDate"
                          class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Vista</label>
                <div class="d-flex is-align-items-stretch">
                  <vs-checkbox v-model="secondView">Segunda Vista</vs-checkbox>
                </div>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Responsable del informe</label>
                <vs-input type="text"
                          v-model="responsibleName"
                          placeholder="Nombre"
                          class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Siglas OACI</label>
                <multiselect v-model="initials"
                             placeholder="Seleccione un OACI"
                             label="id"
                             track-by="id"
                             :options="OACI"
                             :multiple="false"
                             :taggable="true"
                             :max-height="150"
                             :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Aeropuerto</label>
                <vs-input type="text"
                          v-model="parkName"
                          placeholder="Aeropuerto"
                          :disabled="true"
                          class="w-100 "/>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="listAerooriente()">Buscar</vs-button>
                <vs-button color="gray"
                           @click="clearForm()">Limpiar
                </vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx"
                               type="filled"
                               color="danger"
                               @click="download()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>

        <vs-col vs-lg="12" vs-xs="12">
          <div style="max-height: 40em; overflow-y: auto;"
               v-if="!secondView">
            <vs-card style="border-radius: 1.5em;">
              <h3 class="card-title d-flex">
                Tabla de previsualización
              </h3>
              <vs-table :data="tableData"
                        max-items="30"
                        pagination>
                <template slot="thead">
                  <vs-th>Prefijo</vs-th>
                  <vs-th>Número factura</vs-th>
                  <vs-th>Concepto</vs-th>
                  <vs-th>USD TRN</vs-th>
                  <vs-th>COL TRN</vs-th>
                  <vs-th>TRM</vs-th>
                  <vs-th>% iva</vs-th>
                  <vs-th>Iva</vs-th>
                  <vs-th>Total con USD</vs-th>
                  <vs-th>Fecha</vs-th>
                  <vs-th>Máquina</vs-th>
                  <vs-th>Tipo pago</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].prefix">
                      {{ data[indextr].prefix }}
                    </vs-td>
                    <vs-td :data="data[indextr].billNumber">
                      {{ data[indextr].billNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].concept">
                      {{ data[indextr].concept }}
                    </vs-td>
                    <vs-td :data="data[indextr].usdTrn">
                      {{ data[indextr].usdTrn }}
                    </vs-td>
                    <vs-td :data="data[indextr].colTrn">
                      {{ data[indextr].colTrn }}
                    </vs-td>
                    <vs-td :data="data[indextr].trm">
                      {{ data[indextr].trm }}
                    </vs-td>
                    <vs-td :data="data[indextr].percentage">
                      {{ data[indextr].percentage }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].total">
                      {{ data[indextr].total }}
                    </vs-td>
                    <vs-td :data="data[indextr].date">
                      {{ data[indextr].date }}
                    </vs-td>
                    <vs-td :data="data[indextr].machine">
                      {{ data[indextr].machine }}
                    </vs-td>
                    <vs-td :data="data[indextr].typePay">
                      {{ data[indextr].typePay }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </div>
          <div style="max-height: 40em; overflow-y: auto;" v-if="secondView">
            <vs-card style="border-radius: 1.5em;">
              <h3 class="card-title d-flex">
                Tabla de previsualización
              </h3>
              <vs-table :data="tableData"
                        max-items="30"
                        pagination>
                <template slot="thead">
                  <vs-th>Aeropuerto</vs-th>
                  <vs-th>Prefijo</vs-th>
                  <vs-th>Número</vs-th>
                  <vs-th>Fecha factura</vs-th>
                  <vs-th>Concepto</vs-th>
                  <vs-th>Valor parcial</vs-th>
                  <vs-th>% iva</vs-th>
                  <vs-th>Valor iva</vs-th>
                  <vs-th>Valor con iva</vs-th>
                  <vs-th>Máquina</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].airport">
                      {{ data[indextr].airport }}
                    </vs-td>
                    <vs-td :data="data[indextr].prefix">
                      {{ data[indextr].prefix }}
                    </vs-td>
                    <vs-td :data="data[indextr].billNumber">
                      {{ data[indextr].billNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].date">
                      {{ data[indextr].date }}
                    </vs-td>
                    <vs-td :data="data[indextr].concept">
                      {{ data[indextr].concept }}
                    </vs-td>
                    <vs-td :data="data[indextr].colTrn">
                      {{ data[indextr].colTrn }}
                    </vs-td>
                    <vs-td :data="data[indextr].percentage">
                      {{ data[indextr].percentage }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].total">
                      {{ data[indextr].total }}
                    </vs-td>
                    <vs-td :data="data[indextr].machine">
                      {{ data[indextr].machine }}
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import Multiselect from "vue-multiselect";
import DateUtils from "@/global/DateUtils";
import toast from "@/global/ToastConfig";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import ParkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";

export default {
  name: "fiscal-report",
  components: {
    CompanySelector, Multiselect
  },

  data: () => ({

    secondView: false,
    initialDate: null,
    finalDate: null,
    companyId: null,
    parkName: null,
    initials: null,
    responsibleName: null,
    isLoading: false,
    OACI: [
      {name: "INTERNACIONAL CAMILO DAZA CUCUTA ", id: "SKCC",},
      {name: "PALONEGRO BUCARAMANGA", id: "SKBG"},
      {name: "AlFONZO LOPEZ PUMAREJO VALLEDUPAR", id: "SKVP"},
      {name: "SIMON BOLIVAR SANTA MARTA", id: "SKSM"},
      {name: "ALMIRANTE PADILLA RIOACHA", id: "SKRH"},
    ],
    tableData: [],
    airportNames: [],
    forPageElements: 20,
    originalData: [],
    page: 1,
    totalPages: 0,
    lenghtData: 0,
    documents: [],
  }),
  watch: {
    initials(initial) {
      if (!initial) {
        this.parkName = "";
        return
      }
      this.airportNames = this.OACI.filter(item => initial.id === item.id);
      this.parkName = this.airportNames[0].name;
    },
    secondView() {
      this.tableData = [];
    }

  },
  methods: {
    onChangeCompany(company) {
      this.companyId = company.id;
    },
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.responsibleName = null;
      this.tableData = [];

    },
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
          format: "YYYY-MM-DD",
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
          format: "YYYY-MM-DD",
        }),
        initials: this.initials.id,
        responsibleName: this.responsibleName,
        parkName: this.parkName,
        secondView: this.secondView
      };
    },
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if (!this.initials) {
        throw new Error("Argrege iniciales ");
      }
      if (!this.parkName) {
        throw new Error("Argrege Aeropuerto");
      }
    },
    download() {
      try {
        this.validateForm();
        if (!this.responsibleName) {
          throw new Error("Error debe agregar un responsable para descargar");
        }
        this.isLoading = true;
        toast.info("Cargando Reporte");
        const params = this.prepareParameters();
        ParkingReportsEndpoints.downloadAeroriente(params)
            .then(data => {
              if (data.code < 0) {
                toast.error(data.message);
                return;
              }
              downloadEndpoint.downloadFile(data.info);
              toast.ok('Reporte descargado exitosamente');
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
      } catch (error) {
        toast.error(error.message);
        this.isLoading = false;
      }
    },
    listAerooriente() {
      try {
        this.validateForm();
        this.tableData = [];
        this.isLoading = true;
        toast.info('Cargando información');
        const params = this.prepareParameters();
        ParkingReportsEndpoints.previewAeroriente(params)
            .then(data => {
              if (data.code < 0) {
                toast.error(data.message)
                return;
              }
              this.lenghtData = data.info.length;
              this.originalData = data.info;
              this.tableData = data.info;
            })
            .finally(() => {
              this.isLoading = false;
            });
      } catch (error) {
        toast.error(error);
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>